'use strict';

(function () {
	angular.module('onboarding.common')
		.filter('startFrom',
			function () {
				return function (input, start) {
					if (input)
						return input.slice(+start);

					return input;
				};
			});
})();
